import { createAsyncReducer } from 'utils/Redux';
import { GenericResponse } from 'types/GenericResponse';

import { dynamicFilterActions } from '../actions';

export default createAsyncReducer<Record<string, never>, GenericResponse>(
  dynamicFilterActions,
);
